/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateModerationConfig } from 'state/thunks/moderation';
// material
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as SettingsIcon } from 'assets/icons/settings.svg'
// content
import ModerationType from './moderationtype/moderationtype';
// styles
import injectSheet from 'react-jss'
import styles from './generalsection_styles'


/* ========== ~~~~~~~~~~ MODERATION CONFIG V2: GENERAL SECTION ~~~~~~~~~~ ========== */
const GeneralSection = injectSheet(styles)((props) => {

  const dispatch = useDispatch()
  const { isUpdating } =  useSelector(state => state.moderation)
  const savedModerationConfig = useSelector(state => state.moderation.moderationConfig)

  const [moderationConfig, setModerationConfig] = useState(savedModerationConfig)
  const [isOpened, setIsOpened] = useState(false)

  useEffect(() => {
    if(moderationConfig !== savedModerationConfig && !isOpened) setModerationConfig(savedModerationConfig)
  }, [savedModerationConfig, isOpened, moderationConfig])

  const handleToggle = () => setIsOpened(!isOpened)

  const handleSave = useCallback(async () => {
    const response = await dispatch(updateModerationConfig({ moderationConfig }))
    if(response.payload) setIsOpened(false)
  }, [dispatch, moderationConfig])

  const handleCancel = () => {
    setIsOpened(false)
    setModerationConfig(savedModerationConfig)
  }

  const isChanged = useMemo(() => {
    const isFieldsChanged = !(JSON.stringify(moderationConfig) === JSON.stringify(savedModerationConfig));
    return isFieldsChanged
  }, [savedModerationConfig, moderationConfig])


  const handleGeneralConfigChange = (property, value) => {
    setModerationConfig({
      ...moderationConfig,
      [property]: value
    })
  }

  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={isUpdating}
      disableSave={!isChanged}
      saveTitle={'Save Changes'}
      icon={<SettingsIcon />}
      title='General'
    />
  );

  return (
    <ExpandableSection
      className={`expandablesectionv2 generalsection ${props.classes.generalsection}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={isUpdating}
      disableSave={false}
    >
     <ModerationType onChange={value => handleGeneralConfigChange('moderationType', value)} moderationType={moderationConfig.moderationType} /> 
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GeneralSection;